import RssFeedCRUDActions from '../actions/RssFeedCRUDActions';
import Actions from '../actions/actions';
import { retrieved, retrievedAll, update, deleteLocalFirst, setBusy, setUnBusy } from './common/commonReducers';

const initialState = {
  busy: false,
  entities: [],
}

export default function rssFeed(state = initialState, action) {
  switch (action.type) {
    case RssFeedCRUDActions.busyAction: return setBusy(state);
    case RssFeedCRUDActions.retrievedAction: return retrieved(state, action);
    case RssFeedCRUDActions.retrievedAllAction: return retrievedAll(state, action);
    case RssFeedCRUDActions.updateAction: return update(state, action);
    case RssFeedCRUDActions.deleteLocalAction: return deleteLocalFirst(state, action);
    case RssFeedCRUDActions.unbusyAction: return setUnBusy(state);
    case Actions.RESET: return initialState;
    case Actions.UNBUSY: return setUnBusy(state);
    default: return state;
  }
}
